import React from 'react';
import { useTranslation } from 'react-i18next';

import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';

import { useTabParam } from '../../../../common/hooks/use-tab-param.hook';
import { useVendorPlan } from '../../../../common/hooks/use-vendor-plan.hook';

export const ANALYTICS_TABS = ['overview', 'products', 'assistant'] as const;
export type AnalyticsTab = (typeof ANALYTICS_TABS)[number];

const LABELS: Record<AnalyticsTab, string> = {
  overview: 'SIDEBAR.ENGAGEMENT.ANALYTICS_OVERVIEW',
  products: 'SIDEBAR.ENGAGEMENT.ANALYTICS_PRODUCTS',
  assistant: 'VIZ_ANALYTICS.ASSISTANT.TAB',
};

/** The tabs this vendor has: the assistant's only when a super admin granted it. */
export const useAnalyticsTabs = (): readonly AnalyticsTab[] => {
  const { hasFeature } = useVendorPlan();
  return hasFeature('smartAssistant') ? ANALYTICS_TABS : ANALYTICS_TABS.filter((k) => k !== 'assistant');
};

export const useAnalyticsTab = () => useTabParam(ANALYTICS_TABS);

export const AnalyticsTabs: React.FC = () => {
  const { t } = useTranslation();
  const [activeKey, setTab] = useAnalyticsTab();
  const tabs = useAnalyticsTabs();

  // The page renders the tab's content itself (see analytics.page), so there is no TabsContent here.
  return (
    <Tabs value={activeKey} onValueChange={(key) => setTab(key as AnalyticsTab)} className="-mt-2 w-fit">
      <TabsList>
        {tabs.map((key) => (
          <TabsTrigger key={key} value={key} className="px-3">
            {t(LABELS[key])}
          </TabsTrigger>
        ))}
      </TabsList>
    </Tabs>
  );
};
